<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-04-01 17:19:31
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\yearPicker\index.vue
-->
<template>
  <div>
    <DhcFieldInput v-model="formOption" :inputData="formOption.value" placeholder="点击选择年份" :disable="disable" @changeFieldData="changeFieldData"></DhcFieldInput>
    <van-popup v-model="formOption.isPopFlag" position="bottom">
      <van-picker show-toolbar title="选择年份" :columns="yearColumns"
                  @confirm="onYearPickerConfirm" @cancel="formOption.isPopFlag = false"
      >
        <template #option="item">
          {{ item + '年' }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
import { getYearDatas } from '@/utils/date.js'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		}
	},
	data() {
		return {
			dictionary,
			yearColumns: []
		}
	},
	computed: {
		formOption: {
			get: function() {
				return this.value
			},
			set: function() {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				this.yearColumns = getYearDatas(newValue.value)
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 年份选择器确认
		onYearPickerConfirm(value) {
			this.formOption.value = value.toString()
			this.formOption.isPopFlag = false
		},
		// 改变input框数据
		changeFieldData(data) {
			this.formOption = data
		}
	}
}
</script>
<style lang="scss" scoped>
</style>